module.exports = "https://coursera_assets.s3.amazonaws.com/images/6fdf05fda54db26f26562e09c16e4146.jpg";